export const stateName = 'vasGallery';